 <!-- ADDRESS BOOK=========================ADDRESS BOOK=================ADDRESS BOOK===========ADDRESS BOOK -->
<div class="address_book tab_content" id="content8" data-tab="8">
  <cradua-address-book-search
[task]="task"
(searchEmit)="onSearch($event)"
(emitTask)="onTask($event)"
>
</cradua-address-book-search>

<ng-container [ngSwitch]="task">
  <ng-template ngSwitchCase="list">
    <cradua-address-book-list
  [addressBooks]="searchedAddressBook"
  (emitAddressBook)="onViewTask($event)"
  (taskEmit)="onTask($event)">

  </cradua-address-book-list>
  </ng-template>

  <ng-template ngSwitchCase="create">
    <form [formGroup]="addressBookForm">


              <h2 class="title">Address Book</h2>
              <div class="the_input">
                <label for="">Title</label>
                <select formControlName="TitleId" class="default_input">
                  <option  *ngFor="let title of titles"
                  [value]="title.id">{{ title.TitleName }}</option>
                </select>
              </div>
              <div class="contain">
                <div class="the_input">
                  <label for="">Name</label>
                  <input formControlName="Name" type="text" class="default_input" />
                </div>
                <div class="the_input">
                  <label for="">Address</label>
                  <input formControlName="Address" type="text" class="default_input" />
                </div>
                <div class="the_input">
                  <label for="">Telephone</label>
                  <input formControlName="PhoneNo" type="text" class="default_input" />
                </div>
                <div class="the_input">
                  <label for="">Email</label>
                  <input formControlName="Email" type="email" class="default_input" />
                </div>
                <div class="the_input">
                  <label for="">State</label>
                  <select formControlName="StateId"
                    (change)="onFilterLga($event.target.value)"
                     class="default_input">
                    <option  *ngFor="let state of states"
                    [value]="state.id">{{ state.StateName }}</option>
                  </select>
                </div>

                <div class="the_input">
                  <label for="">Local Government Area</label>
                  <select formControlName="LgaId"
                  (change)="onFilterCommunity($event.target.value)"
                  class="default_input">
                    <option *ngFor="let lga of filterLgas"
                    [value]="lga.id">{{ lga.LgaName }}</option>
                  </select>
                </div>

                <div class="the_input">
                  <label for="">Community</label>
                  <select formControlName="CommunityId"

                  class="default_input">
                    <option *ngFor="let community of filterCommunities"
                    [value]="community.id">{{ community.CommunityName }}</option>
                  </select>
                </div>



                <div class="the_input">
                  <label for="">Bank</label>
                  <select formControlName="BankId" class="default_input">
                    <option *ngFor="let bank of banks"
                    [value]="bank.id">{{ bank.BankName }}</option>
                  </select>
                </div>

                <div class="the_input">
                  <label for="">Account Name</label>
                  <input formControlName="AccountName" type="text" class="default_input" />
                </div>

                <div class="the_input">
                  <label for="">Account Number</label>
                  <input formControlName="AccountNo" type="text" class="default_input" />
                </div>

                <div class="the_input">
                  <label for="">Vendor Number</label>
                  <input formControlName="VendorId" type="text" class="default_input" />
                </div>

                <div class="the_input">
                  <label for="">Remark</label>
                  <input formControlName="Remarks" type="text" class="default_input" />
                </div>
              </div>


    <div class="acquisition_submit">
      <button type="submit" *ngIf="activitySelectedValue === 'readwrite'" class="default_primary-button" (click)="onSubmit(addressBookForm.value)" type="submit">Save  &rarr;</button>
     </div>
     </form>
  </ng-template>
  </ng-container>
</div>
<cradua-list-spinner
*ngIf="isLoadingAddressBook === true"
>
</cradua-list-spinner>
